import { Kind } from "@b2bportal/air-booking-api";
import { ensureExhaustive } from "@b2bportal/core-utilities";

/**
 * i18n keys for flight exchange's various price breakdown line items
 */
export const FTC_APPLIED_LABEL_KEY = "exchangeable.priceBreakdown.ftcApplied";
export const PREV_FLIGHT_CREDIT_LABEL_KEY =
  "exchangeable.priceBreakdown.prevFlightCredit";
export const PRICE_FREEZE_CREDIT_LABEL_KEY =
  "exchangeable.priceBreakdown.priceFreezeCredit";
export const SEATS_SUBTOTAL_LABEL_KEY = "exchangeable.priceBreakdown.seats";
export const SUMMARY_SUBTOTAL_LABEL_KEY =
  "exchangeable.priceBreakdown.subtotal";
export const SUMMARY_TOTAL_LABEL_KEY = "exchangeable.priceBreakdown.total";
export const TRAVEL_WALLET_CREDIT_LABEL_KEY = `exchangeable.ancillaries.walletCredit`;
export const TRAVEL_WALLET_OFFER_LABEL_KEY = `exchangeable.ancillaries.walletOffer`;

export const getAncillariesLabelCopyKey = (kind: Kind) => {
  switch (kind) {
    case Kind.CancelOrChange:
      return "exchangeable.ancillaries.CancelOrChange";
    case Kind.Cfar:
      return "exchangeable.ancillaries.Cfar";
    case Kind.Chfar:
      return "exchangeable.ancillaries.Chfar";
    case Kind.Delay:
      return "exchangeable.ancillaries.Delay";
    case Kind.Insurance:
      return "exchangeable.ancillaries.Insurance";
    case Kind.Luggage:
      return "exchangeable.ancillaries.Luggage";
    case Kind.MissedConnection:
      return "exchangeable.ancillaries.MissedConnection";
    case Kind.Points:
      return "exchangeable.ancillaries.Points";
    default:
      return ensureExhaustive(kind, "");
  }
};
